module.exports = __webpack_public_path__ + "static/media/blackfriday-m.a6d3ed64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/banner-carousel/blackfriday-m.png
// module id = 1957
// module chunks = 0